import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { Box, Typography } from '@mui/joy';

import BatteryStatusCard from '../components/HeartBeat/BatteryStatusCard';
import MemoryUsageCard from '../components/HeartBeat/MemoryUsageCard';
import NetworkInterfacesCard from '../components/HeartBeat/NetworkInterfacesCard';
import SystemInfoCard from '../components/HeartBeat/SystemInfoCard';
import { SimpleHeaderLayout } from '../components/layout/SimpleHeaderLayout';
import { DroneHeartBeat } from '../models/DroneProfile/DroneProfile.model';

export default function DroneHeartbeatPage() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const heartbeat = location.state?.heartbeat as DroneHeartBeat | undefined;

  const cancelButton = (
    <Typography onClick={() => navigate('/')} sx={{ cursor: 'pointer', alignSelf: 'center', margin: '1rem' }}>
      {t('edit_profile.cancel')}
    </Typography>
  );

  if (!heartbeat) {
    return (
      <SimpleHeaderLayout controlComponent={cancelButton}>
        <div className="text-center text-red-600 font-medium mt-10">
          {t('register_drone.heartbeat_error')}
        </div>
      </SimpleHeaderLayout>
    );
  }

  return (
    <SimpleHeaderLayout controlComponent={cancelButton}>
      <Box className="flex flex-col gap-4 p-4 w-3/5 mx-auto">
        <SystemInfoCard heartbeat={heartbeat}/>
        <BatteryStatusCard heartbeat={heartbeat}/>
        <MemoryUsageCard heartbeat={heartbeat} />
        <NetworkInterfacesCard heartbeat={heartbeat} />
      </Box>
    </SimpleHeaderLayout>
  );
}
